import { apiPaths } from '@/services/api/paths';
import { TTimeline } from '@/types/Timeline.types.ts';
import { api, TCustomAxiosResponse } from '..';

export const getTimelineForMemberCareMember = async (memberId: string): Promise<TCustomAxiosResponse<TTimeline[]>> => {
  const { data } = await api.get<TCustomAxiosResponse<TTimeline[]>>(apiPaths.timeline.forUser(memberId));
  const timelineItems = data;

  return timelineItems;
};
